function cursor() {
  const cursor = document.querySelector('.cursor')
  const exploraMas = document.querySelectorAll('.cursor-exploramas')
  const descargarBrochure = document.querySelectorAll('.cursor-descargar-brochure')
  const googleMaps = document.querySelectorAll('.cursor-google-maps')

  // Variables para el delay del cursor
  let mouseX = 0
  let mouseY = 0
  let cursorX = 0
  let cursorY = 0
  const delay = 0.1 // Factor de suavizado (0.1 = más delay, 0.9 = menos delay)

  // Optimización: Usar requestAnimationFrame para el mousemove
  let rafId
  document.addEventListener('mousemove', (e) => {
    mouseX = e.clientX
    mouseY = e.clientY
  })

  // Función para animar el cursor con delay
  function animateCursor() {
    // Interpolación lineal para crear el efecto de delay
    cursorX += (mouseX - cursorX) * delay
    cursorY += (mouseY - cursorY) * delay

    cursor.style.transform = `translate(${cursorX}px, ${cursorY}px)`

    requestAnimationFrame(animateCursor)
  }

  // Iniciar la animación
  animateCursor()

  // Verificar si el elemento o alguno de sus padres tiene la clase cursor-avoid
  function hascursorAvoidClass(element) {
    if (!element || element === document.body) return false
    if (element.classList && element.classList.contains('cursor-avoid')) return true
    return hascursorAvoidClass(element.parentElement)
  }

  function handleHover(elements, className) {
    elements.forEach(element => {
      // Usar event delegation para manejar todos los elementos internos
      element.addEventListener('mouseover', (e) => {
        // Si el elemento sobre el que está el cursor tiene la clase cursor-avoid o está dentro de uno, no aplicar el efecto
        if (hascursorAvoidClass(e.target)) {
          cursor.classList.remove(className)
          return
        }
        cursor.classList.add(className)
      })

      element.addEventListener('mouseout', (e) => {
        // Si el elemento al que va el cursor está dentro del mismo contenedor y no tiene la clase cursor-avoid
        if (element.contains(e.relatedTarget) && !hascursorAvoidClass(e.relatedTarget)) {
          return
        }
        cursor.classList.remove(className)
      })
    })
  }

  if (exploraMas?.length) {
    handleHover(exploraMas, 'exploramas')
  }

  if (descargarBrochure?.length) {
    handleHover(descargarBrochure, 'descargar-brochure')
  }

  if (googleMaps?.length) {
    handleHover(googleMaps, 'google-maps')
  }

}

export default cursor
